<div class="attachment-item">
  <div class="attachment-item__content">
    <div class="attachment-item__header">
      <span class="attachment-item__name" [cmTooltip]="attachment().fileName" [cmTooltipShowOnlyIfEllipsis]="true">{{ attachment().fileName }}</span>
      @if (attachment().isAiGenerated) {
        <cm-chip color="info" size="sm">AI Generated</cm-chip>
      }
    </div>

    <div class="attachment-item__meta">
      <span>{{ formattedSize() }}</span>
      @if (attachment().uploadedBy) {
        <span class="attachment-item__separator">|</span>
        <span>Uploaded by {{ attachment().uploadedBy }}</span>
      }
      @if (attachment().uploadedDate) {
        <span class="attachment-item__separator">|</span>
        <span>{{ attachment().uploadedDate | date: 'MMM d, yyyy' }}</span>
      }
    </div>
  </div>

  <div class="attachment-item__actions">
    <cm-action-button
      iconName="download"
      iconColor="neutral"
      iconSize="s"
      iconMode="fill"
      [ariaLabel]="'Download ' + attachment().fileName"
      [title]="'Download ' + attachment().fileName"
      [autId]="'download-attachment-' + attachment().id"
      (click)="onDownloadClick()"
    />

    @if (canDelete()) {
      <cm-action-button
        iconName="delete"
        iconColor="neutral"
        iconSize="s"
        iconMode="fill"
        [loading]="deleting()"
        [ariaLabel]="'Delete ' + attachment().fileName"
        [title]="'Delete ' + attachment().fileName"
        [autId]="'delete-attachment-' + attachment().id"
        (click)="onDeleteClick()"
      />
    }
  </div>
</div>
